export default {
  type: "row",
  style: "",
  id: "no-content-row",
  data: {
    applyImageTo: "row",
    stackOnMobile: "off",
  },
  children: [
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-12",
      children: [
        {
          data: {},
          type: "no-content",
          style: "",
          children: [],
        }
      ],
    },
  ],
};

export const NO_CNT_IN_CNT = {
  data: {},
  type: "no-content",
  style: "",
  children: [],
}